import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { throwError } from 'rxjs';

@Component({
  selector: 'app-approval-feedback',
  templateUrl: './approval-feedback.component.html',
  styleUrls: ['./approval-feedback.component.css']
})
export class ApprovalFeedbackComponent implements OnInit {

  public message: string = '';
  public status: number = 0;
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }

  constructor(
    public ref: DynamicDialogRef,
    public dialogService: DialogService
  ) {
    if (this.ref) {
      try {
        const instance = this.dialogService.getInstance(this.ref);
        this.message = instance.data?.message;
        this.status = instance.data?.status;
      }
      catch (ex) {
        throwError(ex)
      }
    }
  }

  ngOnInit() {
  }

}
